<template>
    <vs-popup id="popup-create-payroll" class="popup-create-payroll" title="Create Payroll" :active.sync="popupCreatePayroll.isOpen">
        <div class="px-5 py-2" v-if="approvePayrollData && approvePayrollData.length > 0">
            <div class="flex align-center justify-between font-bold color-black">
                <p class="text-center">
                    Period payment: {{getDuration(approvePayrollData[0].start_date, approvePayrollData[0].end_date)}} 
                    <span v-if="getDuration(approvePayrollData[0].start_date, approvePayrollData[0].end_date) > 1">Days</span>
                    <span v-else>Day</span></p>
                <p class="text-center text-xl ml-4"> {{changeFormat(approvePayrollData[0].start_date)}} to {{changeFormat(approvePayrollData[0].end_date)}}</p>
                <vs-button class="gradient gradient-primary no-shadow export-btn" @click="exportApprovePayroll">
                    <div class="flex-center">
                        <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
                        Export
                    </div>
                </vs-button>
            </div>

            <div class="create-table-overflow mt-6" v-if="approvePayrollData && approvePayrollData[0] && approvePayrollData[0].employee_list">
                <div class="h-full overflow-auto">
                    <vs-table class="create-table" :data="approvePayrollData[0].employee_list">
                        <template slot="thead">
                            <vs-th class="w-3/12 text-center">Staff</vs-th>
                            <vs-th class="w-1/12 text-center center-title">Commission</vs-th>
                            <vs-th class="w-1/12 text-center center-title">Tip</vs-th>
                            <vs-th class="w-1/12 text-center center-title">Salary</vs-th>
                            <vs-th class="w-1/12 text-center center-title">Card charge</vs-th>
                            <vs-th class="w-1/12 text-center center-title">Supply share</vs-th>
                            <vs-th class="w-1/12 text-center center-title">Deduction</vs-th>
                            <vs-th class="w-1/12 text-center center-title">Cash income</vs-th>
                            <vs-th class="w-1/12 text-center center-title">Check income</vs-th>
                            <vs-th class="w-2/12 text-center center-title">Total</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td class="border-top-custom" :data="tr">
                                    <div class="flex align-center">
                                        <vs-avatar :src="tr.image_url" :text="StringHelper.changeFormatAvatar(tr.name)" :color="tr.color_code" class="border-2 border-solid border-white text-xl mr-4" size="45px"></vs-avatar>
                                        <span class="color-black font-bold" style="max-width: 80%; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;">{{tr.name}}</span>
                                    </div>
                                </vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.commission">${{ +(Math.round(tr.commission + "e+2") + "e-2") }}</vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.tip">${{ +(Math.round(tr.tip + "e+2") + "e-2") }}</vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.salary">${{ +(Math.round(tr.salary + "e+2") + "e-2") }}</vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.card_charge">${{ +(Math.round(tr.card_charge + "e+2") + "e-2") }}</vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.supply_share">${{ +(Math.round(tr.supply_share + "e+2") + "e-2") }}</vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.deduction">${{ +(Math.round(tr.deduction + "e+2") + "e-2") }}</vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.cash_income">${{ +(Math.round(tr.cash_income + "e+2") + "e-2") }}</vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.check_income">${{ +(Math.round(tr.check_income + "e+2") + "e-2") }}</vs-td>
                                <vs-td class="font-bold color-black text-center border-left-custom border-top-custom" :data="tr.total_commission">${{ +(Math.round(tr.total_commission + "e+2") + "e-2") }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>

            <div class="w-full flex-center pt-5">
                <div class="w-1/4 pr-6">
                    <vs-button class="w-full back-btn" color="#AAAAAA" @click="goBack">BACK</vs-button>
                </div>
                <div class="w-1/4 pl-6">
                    <vs-button class="w-full confirm-btn" @click="popupConfirmPayroll.isOpen = true">COMFIRM PAYROLL</vs-button>
                </div>
            </div>
        </div>
        <confirm-payroll-popup :popupConfirmPayroll="popupConfirmPayroll" @closePopup="popupConfirmPayroll.isOpen = false" @saveConfirm="confirmPayroll"></confirm-payroll-popup>
    </vs-popup>
</template>

<script>
import moment from 'moment';
import { changeFormatHelper, formatExportDateString } from '../../helper/datetimeHelper';
import FileDownload from'js-file-download';
import { StringHelper } from "../../models/string_helper";
export default {
    name: 'vs-popup-create-payroll',
    props: {
        popupCreatePayroll: {
            type: Object,
            required: true
        },
        my_filter: {
            type: Object,
            required: true
        }
    },
    data() {
        let format_export_date_string = formatExportDateString();
        return {
            format_export_date_string,
            popupConfirmPayroll: {
                isOpen: false
            },
            isOpenLoading: false,
            action_type: '',
            StringHelper,
        }
    },
    watch: {
        popupCreatePayroll: {
            immediate: true,
            deep: true,
            handler() {
                if(this.popupCreatePayroll.isOpen) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);

        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        goBack() {
            this.$emit('goBack');
        },
        confirmPayroll() {
            this.popupConfirmPayroll.isOpen = false;
            this.$emit('confirmPayroll');
        },
        changeFormat(date) {
            if(date) {
                return changeFormatHelper(date);
            } else {
                return 'N/A';
            }
        },
        getDuration(from, to) {
            if(from && to) {
                return moment(to).diff(moment(from), 'days') + 1;
            }
            return 0;
        },
        exportApprovePayroll() {
            let data = {};
            if(this.approvePayrollData && this.approvePayrollData.length > 0 && this.approvePayrollData[0].start_date) {
                data.start_date = moment(this.approvePayrollData[0].start_date).format('MM/DD/YYYY');
            }
            // if(this.my_filter.to_date) {
            //     data.end_date = moment(this.my_filter.to_date).format('MM/DD/YYYY');
            // }

            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.action_type = "Export Approve Payroll";
            this.$store.dispatch('goPos/EXPORT_APPROVE_PAYROLL', data).then((res) => {
                FileDownload(res.data, `approve-payroll-${moment().format(this.format_export_date_string)}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                this.closeLoading();
                this.$vs.notify({
                    title: "Notification",
                    text: "Export Approve Payroll Success",
                    color: "success",
                    position: "top-right"
                });
            })
        },
    },
    computed: {
        approvePayrollData() {
            // console.log(this.$store.getters["goPos/approvePayrollData"]);
            return this.$store.getters["goPos/approvePayrollData"];
        }
    }
}
</script>